<template>
  <div>
    <div
      class="product-price"
      :class="{ 
        'product-price--variable': isVariable,
        'product-price--discount': salePrice
       }"
    >
      <p>
        <!-- Show price range for variant product
             salePrice is min_price and regularPrice is max_price-->
        <template v-if="showPriceRange && salePrice !== regularPrice">
          <span class="single-box__multiple-attributes__attribute-label">{{ translations.price }}: </span>
          <span class="single-box__multiple-attributes__attribute-value">
            {{ salePrice }} - {{ regularPrice }}
          </span>
        </template>

        <!-- Sale, show discounted price with slaced regular price -->
        <template v-else-if="salePrice && salePrice !== regularPrice">
          <del>
            <span class="amount">
              <bdi>
                <span>
                  {{ regularPrice }}
                </span>
              </bdi>
            </span>
          </del>
          <ins>
            <span class="amount">
              <bdi>
                <span class="single-box__multiple-attributes__attribute-value">
                  {{ salePrice }}
                </span>
              </bdi>
            </span>
          </ins>
        </template>

        <!-- No sale, show only regular price -->
        <span v-else class="amount">
          <bdi>
            <span class="single-box__multiple-attributes__attribute-value">
              {{ regularPrice }}
            </span>
          </bdi>
        </span>

      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "WellsPrice",
  data() {
    return {
      translations: {
        price: ws_vue_store.translations.price,
      }
    };
  },
  props: {
    regularPrice: String,
    salePrice: String,
    isVariable: Boolean,
    showPriceRange: Boolean
  }
};
</script>
